// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SqRZv::-webkit-search-cancel-button{color:#8b919a;cursor:pointer;display:none}`, "",{"version":3,"sources":["webpack://./src/components/searchBar/SearchBar.module.scss"],"names":[],"mappings":"AACA,qCACE,aAAA,CACA,cAAA,CACA,YAAA","sourcesContent":["\n.search::-webkit-search-cancel-button {\n  color: #8B919A;\n  cursor: pointer;\n  display:none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `SqRZv`
};
export default ___CSS_LOADER_EXPORT___;
